"use client";

import { createClient } from "@masterkey/supabase/client";
import { Button } from "@masterkey/ui/button";
import Image from "next/image";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react"; // Import useEffect and useState

export const GoogleSignin = () => {
  const supabase = createClient();
  const searchParams = useSearchParams();

  // Use state to store parameters after component mounts
  const [fromPath, setFromPath] = useState<string | null>(null);
  const [extensionState, setExtensionState] = useState<string | null>(null);

  // Read searchParams only after component mounts on the client
  useEffect(() => {
    if (searchParams) {
      setFromPath(searchParams.get("from") || "/app"); // Default for web login
      setExtensionState(searchParams.get("state")); // Get the state param
    }
  }, [searchParams]); // Re-run if searchParams change

  const handleSignin = async () => {
    // Ensure parameters are loaded before proceeding
    if (fromPath === null) {
      console.error("Login parameters not yet loaded.");
      // Optionally disable the button or show a message
      return;
    }

    // Construct the callback URL for the /api/auth/callback route
    const callbackUrlParams = new URLSearchParams();

    // Pass the original 'from' (which might be the extension URL) as 'next'
    callbackUrlParams.set("next", fromPath);

    // This is a special parameter for the extension to verify the state
    // for authentication
    if (extensionState) {
      callbackUrlParams.set("extension_state", extensionState);
    }

    const finalCallbackUrl = `${window.location.origin}/api/auth/callback?${callbackUrlParams.toString()}`;
    console.log("Constructed callback URL for Supabase:", finalCallbackUrl); // Debug log

    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: finalCallbackUrl, // Use the carefully constructed URL
        // queryParams: { access_type: 'offline', prompt: 'consent' }, // Add if needed
      },
    });
  };

  // Optionally disable button until params are loaded
  const isReady = fromPath !== null;

  return (
    <Button
      onClick={handleSignin}
      variant="outline"
      className="h-10 w-full rounded-md border border-smokeyBlack text-sm hover:bg-gray-100"
      disabled={!isReady} // Disable button until ready
    >
      <Image
        src="/images/login/google.png"
        alt="Google"
        width={16}
        height={16}
        className="mr-2"
      />
      {isReady ? "Continue with Google" : "Loading..."}
    </Button>
  );
};
